module.exports = __webpack_public_path__ + "media/images/common/login_btn2_ov-af404607960f4f58bb172fefb89b6d18.png";